import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var FeatureFlagQueryDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'FeatureFlagQuery'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'flagKey'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'String'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'featureFlag'
        },
        arguments: [{
          kind: 'Argument',
          name: {
            kind: 'Name',
            value: 'key'
          },
          value: {
            kind: 'Variable',
            name: {
              kind: 'Name',
              value: 'flagKey'
            }
          }
        }],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'id'
            }
          }, {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'isActive'
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useFeatureFlagQueryQuery__
 *
 * To run a query within a React component, call `useFeatureFlagQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagQueryQuery({
 *   variables: {
 *      flagKey: // value for 'flagKey'
 *   },
 * });
 */
export function useFeatureFlagQueryQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(FeatureFlagQueryDocument, options);
}
export function useFeatureFlagQueryLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(FeatureFlagQueryDocument, options);
}